import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, of, tap } from 'rxjs';
import { ReferenceService } from '../../generated/auth/services/reference.service';
import * as PortfoliosActions from './portfolios.actions';

@Injectable()
export class PortfoliosEffects {
  private readonly action = inject(Actions);
  private readonly store = inject(Store);
  private readonly service = inject(ReferenceService);

  constructor() {}

  loadPortfoliosByType$ = createEffect(() =>
    this.action.pipe(
      ofType(PortfoliosActions.loadPortfoliosByType),
      tap(() => this.store.dispatch(PortfoliosActions.togglePortfoliosByTypeLoading({ loading: true }))),
      mergeMap((action) =>
        this.service
          .referenceSasSecLookupGetPortfoliosByTypeGet({ portfolioTypeId: Number(action.portfolioTypeId) })
          .pipe(
            map((response) => {
              this.store.dispatch(PortfoliosActions.togglePortfoliosByTypeLoading({ loading: false }));
              return PortfoliosActions.loadPortfoliosByTypeSuccess({ portfolios: response.result || [] });
            }),
            catchError((error) => {
              this.store.dispatch(PortfoliosActions.togglePortfoliosByTypeLoading({ loading: false }));
              return of(PortfoliosActions.loadPortfoliosByTypeFailure({ error }));
            }),
          ),
      ),
    ),
  );

  loadAllPortfolios$ = createEffect(() =>
    this.action.pipe(
      ofType(PortfoliosActions.loadAllPortfolios),
      tap(() => this.store.dispatch(PortfoliosActions.toggleAllPortfoliosLoading({ loading: true }))),
      mergeMap(() =>
        this.service
          .referenceSasSecLookupGetPortfoliosGet()
          .pipe(
            map((response) => {
              this.store.dispatch(PortfoliosActions.toggleAllPortfoliosLoading({ loading: false }));
              return PortfoliosActions.loadAllPortfoliosSuccess({ portfolios: response.result || [] });
            }),
            catchError((error) => {
              this.store.dispatch(PortfoliosActions.toggleAllPortfoliosLoading({ loading: false }));
              return of(PortfoliosActions.loadAllPortfoliosFailure({ error }));
            }),
          ),
      ),
    ),
  );
}
